<template>
  <div>
    <div class="comment-wrapper flex" :id="'post-' + comment.id" v-if="initial_load_complete">
      <div class="flex-1 flex-no-padding">
        <div class="profile-icon-l relative">
          <template v-if="comment.user().active_trophy">
            <template v-if="comment.user().active_trophy.icon">
              <trophy :trophy="comment.user().active_trophy"
                      :showTitle="false"
                      :showDesc="false"
                      :size="20"
                      :displayOnFeed="true"
                      orientation="horizontal">
              </trophy>
            </template>
          </template>
          <a :href="'/profile/' + comment.user().username">
            <img :src="comment.user().avatar" onerror="this.src='/img/avatar.png'">
          </a>
        </div>
      </div>
      <div class="flex-16 flex-no-padding comment-content relative">
        <div class="comment-full-border"></div>
        <div class="comment">
          <div class="comment-text normal-text"
               :class="{'highlighted-comment': comment.highlighted || focusComment}">

            <template v-if="comment.user().isAdmin && settings.admin_badge_image !== ''">
              <img class="admin-badge" :src="settings.admin_badge_image"/>
            </template>
            <template v-else-if="comment.user().isModerator && settings.moderator_badge_image !== ''">
              <img class="admin-badge" :src="settings.moderator_badge_image"/>
            </template>

            <i v-if="comment.user().streak >= settings.onfire_count && plugins.gamification"
               class="far fa-fire onfire-icon"></i>

            <a class="profile-name hover-opacity" :href="'/profile/' + comment.user().username">
              {{ comment.user().name }}
              <i v-if="topic.user().birth_date && stripYears(topic.user().birth_date) === stripYears(now)"
                 class="far fa-birthday-cake secondary-c"></i>
            </a>
            <div class="comment-media-tags best-answer mimic-title"
                 v-if="topic.answered && comment.accepted_answer">
              <span>{{ $t('forum.best_answer') }}</span>
            </div>
            <i :class="{'animate-toggle' : media_visible}" v-if="user"
               class="fa fa-ellipsis-v post-media-mobile-toggle extra-light-text float-right hover-opacity blue-bg no-select"
               @click="openMediaDropdown"></i>
            <div class="post-media comment-media no-select" v-if="user" v-show="media_visible"
                 v-click-outside="closeMediaDropdown">
              <div class="media-item-wrapper inline-block hover"
                   v-if="!topic.closed && comment.permissions.includes('EDIT') && !isGIF"
                   @click="setEditing(true, comment); closeMediaDropdown();">
                <i class="fal fa-edit secondary-c-hover extra-light-text mimic-title"></i>
                <span class="inline-block">{{ $t('fields.edit') }}</span>
              </div>
              <div class="media-item-wrapper inline-block hover" v-if="comment.permissions.includes('DELETE')"
                   @click="openPopup('delete_feed_item', {item: comment, type: 'comment'}); closeMediaDropdown();">
                <i class="fal fa-trash secondary-c-hover extra-light-text mimic-title"></i>
                <span class="inline-block">{{ $t('fields.delete') }}</span>
              </div>
              <div class="media-item-wrapper inline-block hover"
                   v-if="!topic.answered && viewType !== 'moodview' && comment.permissions.includes('ACCEPT_ANSWER') || comment.accepted_answer && viewType !== 'moodview' && comment.permissions.includes('ACCEPT_ANSWER')"
                   @click="answerTopic({topic: topic, comment: comment, answered: topic.answered}); closeMediaDropdown();"
                   :class="{'active-media-item bold-text': topic.answered && comment.accepted_answer}">
                <i class="fal fa-check secondary-c-hover extra-light-text mimic-title"
                   :class="{'fa bold-text': topic.answered && comment.accepted_answer}">
                </i>
                <span class="inline-block" v-if="!topic.answered">{{ $t('forum.mark_as_answer') }}</span>
                <span class="inline-block" v-else>{{ $t('social.best_answer_remove') }}</span>
              </div>
            </div>
            <div v-if="!editing_content">
              <template v-if="expanded">
                <div class="message-content" v-html="commentContent"></div>
              </template>
              <template v-else>
                <div class="message-content inline" v-html="commentExcerpt"></div>
                <a @click="expandComment(topic)" v-if="commentContent.length > commentExcerpt.length">
                  <p class="extra-light-text inline hover-opacity topic-read-more no-select">
                    ... {{ $t('forum.read_more').toLowerCase() }}
                  </p>
                </a>
              </template>
            </div>
            <huddle-editor-v2
                v-if="comment.permissions.includes('EDIT') && editing_content"
                class="edit-comment-content"
                :init_on_mount="true"
                :cursor_to_end_on_init="true"
                v-model="comment.content"
                :submit_on_enter="true"
                :submittable="true"
                :gifs="true"
                :emojis="true"
                :mentions="true"
                :channelId="topic.board_id"
                :mobile_send_btn="true"
                :customData="{item: comment}"
                @keydown.esc.native="setEditing(false, comment)"
                @submit="submitEditItem">
            </huddle-editor-v2>
            <!--v-on:modelUpdate="updateCommentContent"-->
            <!--v-on:editorEnterEmit="submitNewReply"-->
            <div class="message-attachments">
              <lightbox :images="comment.attachments" thumbnailSrc="source" src="source"
                        customImageClass="message-attachment"></lightbox>
              <div v-for="attachment in comment.attachments" class="comment-attachment light-text hover-opacity"
                   :key="attachment.id">
                <a v-if="attachment.filetype.substring(0, 5) !== 'image'" :href="attachment.source" target="_blank"><i
                    class="far fa-paperclip"></i> {{ attachment.name }}</a>
              </div>
            </div>
          </div>
          <div class="comment-details">
            <div class="comment-karma comment-desc-item extra-light-text inline tiny-text"
                 v-if="comment.user().level && plugins.gamification">
              Level {{ comment.user().level }}
            </div>

            <div class="comment-timestamp comment-desc-item extra-light-text tiny-text">
              <i class="far fa-clock"></i>
              {{ comment.created_at | getDateHumanFormat }}
            </div>
            <div
                class="comment-reply-to-vue-inline comment-desc-item inline-block comment-empty-replies tiny-text light-text secondary-c-hover"
                @click="setShowNewReply(true)"
                v-if="user && repliesLength === 0 && !topic.closed && !user.impersonating">
              <i class="far fa-reply"></i>
              {{ $t('forum.reply_to_comment') }}
            </div>
            <div
                class="comment-reply-to-vue-inline comment-desc-item inline-block comment-empty-replies tiny-text light-text secondary-c-hover"
                @click="setShowNewReply(true)"
                v-if="!user">
              <i class="far fa-reply"></i>
              <a href="/login">Login om te kunnen reageren</a>
            </div>
            <div class="like comment-like comment-desc-item extra-light-text mimic-title no-select tiny-text">
              <p v-if="comment.likesCount > 0" class="count" :class="{'secondary-c' : comment.liked_by_me}">
                {{ comment.likesCount }}</p>
              <p class="count" v-else>0</p>
              <i class="far"
                 :class="[{'font-blue' : comment.liked_by_me}, {'secondary-c-hover': user && !topic.closed && !user.impersonating}, settings.like_icon]"
                 @click="likePost({id: comment.id, bool: !comment.liked_by_me, model: comment.plural, object: comment, closed: topic.closed})"></i>
              <template v-if="user">
                            <span v-if="comment.likesCount > 0" class="like-names">
                                <template v-for="like in comment.likes()">
                                    <span class="like-name">{{ like.name }}</span>
                                    <br>
                                </template>
                            </span>
                <span v-else class="like-names">
                                <span class="like-name empty-likes">{{ $t('social.no_likes_first') }}!</span><br/>
                            </span>
              </template>
            </div>
          </div>
          <!-- comment replies -->
          <div class="comment-replies">
            <!-- load more replies -->
            <span @click="loadReplies(true)"
                  v-if="!singleTopic && total_replies > repliesLength"
                  class="load-more extra-light-text hover-opacity no-select tiny-text"
                  :class="{'paginating': currently_paginating}">
                            <i class="far fa-chevron-double-up inline" style="padding-right: 5px;"></i>
                            <p class="inline">{{ total_replies - repliesLength }} {{ $t('forum.more_replies') }}</p>
                        </span>

            <!-- replies -->
            <transition-group name="simple-conversation-fade">
              <reply v-for="reply in orderedReplies" :focusCommentByHashId="focusCommentByHashId"
                     :key="reply.id" :topic="topic" :comment="comment" :reply="reply"></reply>
            </transition-group>

            <!-- new reply for when there already are replies -->
            <div class="comment-reply-to-vue light-text secondary-c-hover"
                 v-if="repliesLength > 0 && !topic.closed && topic.permissions.includes('REPLY') && !user.impersonating">
              <huddle-editor-v2
                  v-model="new_reply"
                  :submit_on_enter="true"
                  :submittable="true"
                  :gifs="true"
                  :emojis="true"
                  :mentions="true"
                  :channelId="topic.board_id"
                  :mobile_send_btn="true"
                  :placeholder="$t('social.add_comment')"
                  :customData="{topic: topic, comment: comment.id, user: user}"
                  @submit="submitNewReply">
              </huddle-editor-v2>
            </div>

            <!-- new reply for when there arent any replies yet -->
            <div class="comment-new-reply-vue"
                 v-if="repliesLength === 0 && !topic.closed && topic.permissions.includes('REPLY') && !user.impersonating">
              <huddle-editor-v2
                  v-if="new_reply_visible"
                  :init_on_mount="true"
                  v-model="new_reply"
                  :submit_on_enter="true"
                  :submittable="true"
                  :gifs="true"
                  :emojis="true"
                  :mentions="true"
                  :mobile_send_btn="true"
                  :channelId="topic.board_id"
                  :placeholder="$t('social.reply_comment')"
                  :customData="{topic: topic, comment: comment.id, user: user}"
                  @submit="submitNewReply">
              </huddle-editor-v2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import axios from 'axios'
import orderBy from 'lodash.orderby';
import {mapMutations, mapState} from 'vuex';

//mixins
import Feed from '../../mixins/Feed.js'
import Global from '../../mixins/Global.js'
import Modal from '../../mixins/v2/Modal';
import Moment from "../../mixins/Moment.js";

import {EventBus} from '../../lib/event-bus'

export default {
  mixins: [Feed, Global, Moment, Modal],
  name: 'Comment',

  props: {
    topic: {},
    comment: {},
    singleTopic: {
      default: false
    },
    focusCommentByHashId: {
      default: false
    },
    viewType: false,
  },

  data() {
    return {
      expanded: false,
      failed: false,
      pagination: false,
      currently_paginating: false,
      initial_load_complete: false,
      total_replies: false,
      new_reply: '',
      new_reply_visible: false,
    }
  },
  computed: {
    ...mapState([
      'settings',
      'plugins',
      'reply_load_timeout'
    ]),

    commentContent() {
      return this.contentFilter(this.comment, false, false);
    },

    commentExcerpt() {
      return this.contentFilter(this.comment, false, 110);
    },

    repliesLength() {
      return this.comment.replies().length;
    },

    orderedReplies() {
      return orderBy(this.comment.replies(), 'created_at', 'asc');
    },

    focusComment() {
      if (parseInt(this.focusCommentByHashId) === this.comment.id) {
        //set the highlight variable of the comment to true
        this.$store.commit('highlightFeedItem', { item: this.comment });

        let options = {
          offset: -300
        };

        this.$nextTick(() => {
          this.$scrollTo('#post-' + this.comment.id, 500, options);
        });

        return true;
      }

      return false;
    },

    isGIF() {
      return this.comment.content.indexOf('https://media.tenor.com') !== -1;
    }
  },

  created() {
    //show entire topic if it is a single topic page
    if (this.singleTopic) {
      this.expandComment();
    }
  },

  methods: {
    ...mapMutations([
      'increaseReplyTimeout',
      'decreaseReplyTimeout'
    ]),

    submitNewReply(payload) {
      //if content is present then it is a submit on enter
      if (typeof payload.content !== 'undefined') {
        if (payload.content !== '') {
          let data = {
            'in_reply_to': payload.custom_data.comment,
            'content': payload.content,
            'upload_uuids': [],
          };

          this.$store.dispatch(
              {
                type: 'submitReply',
                data: {
                  payload: payload,
                  data: data,
                  id: payload.custom_data.topic.id,
                }
              }
          );
        }
      } else {
        //its a GIF
        let data = {
          'content': '<img src="' + payload.gif + '">',
          'in_reply_to': payload.custom_data.comment,
          'upload_uuids': [],
        };

        this.$store.dispatch(
            {
              type: 'submitReply',
              data: {
                payload: payload,
                data: data,
                id: payload.custom_data.topic.id,
              }
            }
        );
      }
    },

    answerTopic(payload) {
      let self = this;
      let topic = payload.topic;
      let comment = payload.comment;
      let answer = payload.answered;

      this.$store.dispatch(
          {
            type: 'activeDataAction',
            data: {
              model: 'Topic',
              crud_method: 'update',
              sub_path: '/comments/' + comment.id,
              save_data: {
                'conversation[id]': topic.id,
                id: comment.id,
                accept_answer: !answer,
              },
              success_callback: function (response) {
                success_callback(response)
              }
            }
          }
      );

      let success_callback = function (response) {
        self.$store.commit('updateCommentAnswered', {
          topic: topic,
          comment: comment,
          bool: !payload.answered
        });
      }
    },

    expandComment(topic) {
      EventBus.$emit('prevent-from-closing', true);
      this.expanded = true;

      if (topic) {
        this.$store.dispatch(
            {
              type: 'activeDataAction',
              data: {
                model: 'Topic',
                crud_method: 'update',
                custom_verb: 'post',
                sub_path: '/api/v3/notifications/track',
                save_data: {
                  'conversation': topic.id
                }
              }
            }
        );
      }

    },

    loadReplies(paginate = true) {
      if (!this.currently_paginating) {
        this.currently_paginating = true;

        let url = '/api/v2/comments';

        let params = new URLSearchParams();

        params.append('comment_id', this.comment.id);

        if (this.pagination) {
          params.append('page', this.pagination.current_page + 1);
        }

        if (paginate) {
          params.append('limit', 10);
        }

        let request = {
          params: params
        };

        axios.get(url, request)
            .then((response) => {
              //comments data
              let replies = response.data;

              //if this is the first pagination after the initial load, remove the first 3 comments as we already have them stored
              if (paginate && response.data.meta.current_page === 1 && this.initial_load_complete) {
                replies.data.splice(0, 3);
              }

              let data_models = [
                {
                  model: 'Reply',
                  source: 'data',
                  nested_models: [
                    {
                      model: 'Like',
                      source: 'liked_by',
                      storage: 'likes',
                      parent_key: 'reply_id',
                    }
                  ]
                }
              ];

              ActiveDataStore.activeDataSetup(data_models, replies);

              //always save total amount of items so we can see if pagination is needed/possible
              if (response.data.meta) {
                this.total_replies = response.data.meta.total;

                //only add pagination data when we are paginating and not on the initial load
                if (paginate) {
                  this.pagination = response.data.meta;
                }
              }

              this.currently_paginating = false;
              this.failed = true;
              this.initial_load_complete = true;
            }, error => {
              this.failed = true;
              this.currently_paginating = false;
            });
      }
    },
    setShowNewReply(bool) {
      this.new_reply_visible = bool;
    },
  },

  mounted() {
    /* if(!this.singleTopic) {
        this.increaseReplyTimeout();

        setTimeout(() => {
            this.decreaseReplyTimeout();
            //this.loadReplies(false);
            this.initial_load_complete = true;
        }, this.reply_load_timeout);
    } else {
        this.initial_load_complete = true;
    } */
    this.initial_load_complete = true;
  },
}
</script>
